import { ForwardedRef, forwardRef } from 'react';
import styles from '@features/categories/components/CategoriesFilterRange/CategoriesFilterRange.styles';
import FilterRangeState from '@features/categories/mobx/state/FilterRangeState';

type PropsType = {
  props: Record<string, unknown>;
  children: React.ReactNode;
  value: number[];
  filter: FilterRangeState;
};

const CategoriesFilterRangeTrack = forwardRef(
  ({ props, children, value, filter }: PropsType, ref: ForwardedRef<HTMLDivElement>) => {
    const { style, onMouseDown, onTouchStart } = props;

    return (
      // biome-ignore lint/a11y/noStaticElementInteractions: range slider track
      // biome-ignore lint/a11y/noNoninteractiveElementInteractions: range slider track
      <div
        ref={ref}
        onMouseDown={onMouseDown as React.MouseEventHandler}
        onTouchStart={onTouchStart as React.TouchEventHandler}
        style={style as React.CSSProperties}
        sx={styles.trackContainer}
      >
        <div sx={styles.track(value, filter.defaultValue)} aria-hidden="true" />
        {children}
      </div>
    );
  },
);

CategoriesFilterRangeTrack.displayName = 'CategoriesFilterRangeTrack';

export default CategoriesFilterRangeTrack;
